export default __webpack_public_path__ + "static/DSC_0053-eaf8b0ca05a98b759277bd3715ae8bc7.jpg";